import React, { Component } from 'react'
import $ from 'jquery'
import Pagination from './Pagination.jsx';
import { apiClient,apiBaseUrl } from "../helpers/common";
import SimpleReactValidator from 'simple-react-validator';
import swal from 'sweetalert';
import axios from "axios";

class Store extends Component {

    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();

        this.state = {
            totalRecords: 0,
            totalItems: [],
            pageOfItems: [],
            showPagination: false,
            pageSize: 20,
            name: '',
            sellerList:[],
            seller:'',
            store_id: '',
            image:'',
            description:'',
            isEdit:false,
            image:''
        };
    }
    componentDidMount() {

        if (sessionStorage.getItem('adminDetails') !== undefined && sessionStorage.getItem('adminDetails') !== null) {
            this.getStoresList();
            this.getSellerList()
        } else {
            window.location.replace("/admin-login");
        }
    }
    componentDidUpdate() {

    }
    onChangePage = (items) => {
        this.setState({ pageOfItems: items });
    }
    getStoresList = async () => {
        let postData = {
            token: JSON.parse(sessionStorage.getItem('adminDetails')).token,
        }

        const result = await apiClient('stores-listing', {
            method: 'POST',
            body: postData
        });

        if (result.status === 200) {
            let pagination =  result.data.length > 10 ? true :false
            this.setState({ totalItems: result.data, totalRecords: result.data.length ,showPagination:pagination})
        } 
    }
    
    changeStatus = async(e,id) =>{
        e.preventDefault();
    
        let postData = {
            token: JSON.parse(sessionStorage.getItem('adminDetails')).token,
            uuid: id,
            status:e.target.value
        }

        const result = await apiClient('active-deactive-store', {
            method: 'POST',
            body: postData
        });

        if (result.status === 200) {
            this.getStoresList()
        }
    }

    showImage=(image)=>{
        this.setState({image},()=>{
            window.$("#showImage").modal('show')
        })

    }

    storesListing = (data) => {
        if (data && data.length) {
            return (
                data.map((val, i) => {
                    return (
                        <tr key={i + 1} >
                            <td style={{ width: '10%' }}>{val.uuid}</td>
                            <td style={{ width: '10%' }}>{val.createdat}</td>
                            <td style={{ width: '10%' }}>{val.name}</td>
                            <td style={{ width: '10%' }}>{val.sellername}</td>
                            <td style={{ width: '10%' }}>{val.totalProducts}</td>
                            <td style={{ width: '10%' }}>{val.TotalOrders}</td>
                            <td style={{ width: '10%' }}>{val.TotalAmount}</td>
                            <td style={{ width: '10%' }}><a href="javascript:void(0)" onClick={()=>this.showImage(val.image)}>show</a></td>
                            <td style={{ width: '10%' }}>
                                {
                                    val.status === 'A' ? 'Active': val.status === 'D' ? 'Inactive' :val.status ==='T'  ? 'Deleted' :''
                                }
                            
                            </td>
                            <td style={{ width: '10%' }}>
                                {
                                     val.status !== 'T' ? <>
                                      <a href="javascript:void(0)" className="ml-3" onClick={() => this.getStoreDetail(val.uuid)}><i className="fa fa-pencil"></i></a> &nbsp;&nbsp; 
                                      <a href="javascript:void(0)" onClick={(e) => this.handleDeleteAction(val.uuid)}><i className="fa fa-trash-o"></i></a> 
                                      </> :''
                                }
                              
                            </td>
                        </tr>
                    )
                })
            )
        }
    }

    getStoreDetail = async (id) => {
       let storeDetail = this.state.totalItems.filter((val)=>{return val.uuid  === id})
  
       this.setState({
        name: storeDetail[0].name,
        seller: storeDetail[0].sellerid,
        image: storeDetail[0].image,
        description: storeDetail[0].description,
        isEdit:true,
        store_id: storeDetail[0].uuid
      },()=>{
         window.$('#addStorePopup').modal('show')
      })
    
      
    }
    handleSubmit = async (e) => {
        e.preventDefault();
        const {isEdit, name, seller ,image,description,store_id} = this.state

        let img = ''
        if(image !== ''){
           let imgdata = image.split("/")
            img = imgdata[imgdata.length -1]
        }
        if(isEdit){
            if (this.validator.allValid()) {
                let postData = {
                    token: JSON.parse(sessionStorage.getItem('adminDetails')).token,
                    name,
                    image:img,
                    description,
                    sellerid:seller,
                    uuid: store_id
                }
        
                const result = await apiClient('update-store', {
                    method: 'POST',
                    body: postData
                });
        
                if (result.status === 200) {
                    this.setState({ store_id: '' })
                    this.getStoresList();
                    window.$("#addStorePopup").modal('hide');
                }
            } else {
                this.validator.showMessages();
                this.forceUpdate();
            }
          
        }else{
            if (this.validator.allValid()) {
                let postData = {
                    token: JSON.parse(sessionStorage.getItem('adminDetails')).token,
                    name,
                    sellerid:seller,
                    image:img,
                    description,
                }
                const result = await apiClient('add-store', {
                    method: 'POST',
                    body: postData
                });
        
                if (result.status === 200) {
                    this.getStoresList();
                    window.$("#addStorePopup").modal('hide');
                }
            } else {
                this.validator.showMessages();
                this.forceUpdate();
            }

         
        }
      
    }

    handleInputValue = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }
    
    handleDeleteAction = (id) => {
        let postData = {
            token: JSON.parse(sessionStorage.getItem('adminDetails')).token,
            uuid: id,
        }
        swal({
            title: "Are you sure you want to delete this store?",
            closeOnClickOutside: false,
            buttons: true,
            dangerMode: true,
        }).then(async (isOk) => {
            if (isOk) {
                const result = await apiClient('delete-store', {
                    method: 'POST',
                    body: postData
                });

                if (result.status === 200) {
                    this.getStoresList();
                }
            } else {
                console.log('you clicked on false');
            }
        });
    }

    filterData = (e,key) => {

        let updatedList = this.state.totalItems;
        updatedList = this.state.totalItems.filter((val) => {
            if(e.target.value !== ''){
                if(val[key] !== null){
                    if(key === 'age'){
                        return val[key].toString().search(e.target.value) !== -1 ;
                    }else{
                        return val[key].toLowerCase().search(e.target.value.toLowerCase()) !== -1 ;
                    }
                
                }
            }else{
                return val
            }
        });
       
        this.setState({ 
            pageOfItems: updatedList.slice(0, 10),
            showPagination:updatedList.length > 10 ? true:false 
        });
    }

    refreshState =()=>{
        this.setState({
            name:'',
            seller:'',
            image:'',
            description:'',
            isEdit:false
        })
    }

    getSellerList = async () => {
        let postData = {
            token: JSON.parse(sessionStorage.getItem('adminDetails')).token,
        }

        const result = await apiClient('sellers-listing', {
            method: 'POST',
            body: postData
        });

        if (result.status === 200) {
          this.setState({sellerList:result.data})
        }
    }

    handleChangeFile=(event)=>{
        const file = event.target.files[0];
        console.log("file",file)
        const formData = new FormData();
        formData.append('file', file);
     

        axios.post(`${apiBaseUrl}/upload-image`,formData).then(res => {
            if(res.status === 200){
               let img = res.data.data.ImagePath
               this.setState({image:img})
            }
          
        })
    }
    
    render() {
        const { pageSize,isEdit } = this.state
        return (<>
            <div className="page_content">
                <section className="upper_section">
                    <div className="page_heading row">
                        <h3><span className="title">Stores</span></h3>
                        <div className="page_actions">
                        <a href="javascript:void(0)" className="ml-3" data-toggle="modal" data-target="#addStorePopup"><button type="submit" className="btn btn-default" onClick={()=>this.refreshState()}>Add Store</button></a>
                        </div>
                    </div>
                </section>
                <section className="lower_section">
                    <div className="row">
                        <div className="col-md-12 table-responsive  mt-3">
                            <div className="container-fluid bg-white p-0 mb-15 pb-0">
                                <table className="table table-striped table-bordered mb-0">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '10%' }}>Store ID</th>
                                            <th style={{ width: '10%' }}>Created On</th>
                                            <th style={{ width: '10%' }}>Store Name</th>
                                            <th style={{ width: '10%' }}>Seller</th>
                                            <th style={{ width: '10%' }}>Total Products</th>
                                            <th style={{ width: '10%' }}>Total Orders</th>
                                            <th style={{ width: '10%' }}>Total Amount</th>
                                            <th style={{ width: '10%' }}>Image</th>
                                            <th style={{ width: '10%' }}>Status</th>
                                       
                                            <th style={{ width: '10%' }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                       <tr>
                                            <td style={{ width: '10%' }}></td>
                                            <td style={{ width: '10%' }}></td>
                                            <td style={{ width: '10%' }}><input type="text" onChange={(e)=>this.filterData(e,'name')} className="form-control" /></td>
                                            <td style={{ width: '10%' }}><input type="text" onChange={(e)=>this.filterData(e,'sellername')} className="form-control" /></td>
                                            <td style={{ width: '10%' }}></td>
                                            <td style={{ width: '10%' }}></td>
                                            <td style={{ width: '10%' }}></td>
                                            <td style={{ width: '10%' }}></td>
                                            <td style={{ width: '10%' }}></td>
                                            <td style={{ width: '10%' }}></td>
                                        </tr>
                                        {this.storesListing(this.state.pageOfItems)}
                                    </tbody>
                                </table>

                            </div>
                        </div>
                        <div className="col-md-12 pt-3 pagingWrap pb-3">
                            <div className="row">
                                {this.state.totalRecords > 0  ? <Pagination items={this.state.totalItems} onChangePage={this.onChangePage} /> : ''}
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/*Add Store*/}
            <div className="modal fade smallmodalwrap " id="addStorePopup" tabIndex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog smallmodal" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                       <h5 className="modal-title capcase mr-auto ng-binding">{isEdit ? 'Edit':'Add'} Store</h5>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <form onSubmit={(e) => this.handleSubmit(e)}>
                                        <div className="form-group">
                                            <label className="">Name</label>
                                            <input type="text" name="name" value={this.state.name} onChange={(e) => this.handleInputValue(e)} className="form-control"  />
                                            {this.validator.message('name', this.state.name, 'required', { messages: { default: 'Name field is required.'} })}
                                        </div>
                                        <div className="form-group">
                                                <label className="">Seller</label>
                                                <select className ="form-control"
                                                  name ="seller"
                                                  value={this.state.seller}
                                                  onChange={(e) => this.handleInputValue(e)} 
                                               >
                                                <option value=''>Select Seller</option>
                                                   {
                                                      this.state.sellerList.map((val,k)=>{
                                                           return(
                                                                <option key ={k+1} value={val.uuid}>{val.name}</option>
                                                           )
                                                          
                                                       })
                                                   }
                                                
                                               </select>
                                              
                                                {this.validator.message('seller', this.state.seller, 'required', { messages: { default: 'Seller field is required.' } })}
                                            </div>
                                            <div className="form-group">
                                                <label className="">Image</label>
                                                <input type="file" name="file" accept="image/*"  onChange={(e) => this.handleChangeFile(e)} className="form-control" />
                                                {
                                                    this.state.image !== '' ? <>
                                                    <img heigth ="50" width="50" src={this.state.image}/>
                                                     </> :''
                                                }
                                                {this.validator.message('image', this.state.image, 'required', { messages: { default: 'Image is required.' } })}
                                            </div>
                                            <div className="form-group">
                                                <label className="">Description</label>
                                                <textarea name="description" value={this.state.description} onChange={(e) => this.handleInputValue(e)} className="form-control">

                                                </textarea>

                                                {this.validator.message('description', this.state.description, 'required', { messages: { default: 'Description field is required.' } })}
                                            </div>
                         
                            
                                        <div className="row mt-3">
                                            <div className="col-md-12 text-right">
                                                <button type="button" data-dismiss="modal" className="btn-link">Cancel</button>
                                                <button type="submit" className="btn btn-green btn-mini float-right">{isEdit ? 'Update': 'Save'}</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer"></div>
                    </div>
                </div>
            </div>

            
            {/*Image*/}
            <div className="modal fade smallmodalwrap img_modal"  id="showImage" tabIndex="-1" role="dialog"  data-keyboard="false" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog smallmodal" role="document">
                    <div className="modal-content img_modal">
                        {/* <div className="modal-header">
                     
                        </div> */}
                        <div className="modal-body mid_sec_img">
                            <div className="row">
                                <div className="cross">
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div>
                                <div className="col-md-12">
                                    <img src={this.state.image}></img>
                                </div>
                            </div>
                        </div>
                        {/* <div className="modal-footer"></div> */}
                    </div>
                </div>
            </div>
        </>)
    }
}
export default Store